import Reducers from "./reducers";
import { createStore } from "redux";
import throttle from "lodash/throttle";

import { name } from "../core/config";

export const loadStore = () => {
  try {
    const serializedState = localStorage.getItem(name);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveStore = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(name, serializedState);
  } catch {
    // ignore write errors
  }
};

// Redux Middleware
const persistedState = loadStore();
export const store = createStore(Reducers, persistedState);
store.subscribe(
  throttle(() => {
    saveStore({
      Store: store.getState().Store,
    });
  }, 1000)
);
